import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface ReportsFilters {
  since?: string;
  until?: string;
  event?: string;
  products?: string[];
  lotCode?: string[];
  refDocType?: string;
  refDocNumber?: string[];
}

interface ReportsFiltersContextType {
  filters: ReportsFilters;
  setFilters: (filters: ReportsFilters) => void;
  clearFilters: () => void;
  activeFiltersCount: number;
}

const ReportsFiltersContext = createContext<
  ReportsFiltersContextType | undefined
>(undefined);

export const useReportsFilters = () => {
  const context = useContext(ReportsFiltersContext);
  if (!context) {
    throw new Error(
      'useReportsFilters must be used within a ReportsFiltersProvider'
    );
  }
  return context;
};

interface ReportsFiltersProviderProps {
  children: ReactNode;
}

export const ReportsFiltersProvider: React.FC<ReportsFiltersProviderProps> = ({
  children,
}) => {
  const [filters, setFiltersState] = useState<ReportsFilters>({});

  const setFilters = (newFilters: ReportsFilters) => {
    setFiltersState(newFilters);
  };

  const clearFilters = () => {
    setFiltersState({});
  };

  const activeFiltersCount = Object.values(filters).filter(value =>
    Array.isArray(value) ? value.length > 0 : !!value
  ).length;

  return (
    <ReportsFiltersContext.Provider
      value={{ filters, setFilters, clearFilters, activeFiltersCount }}
    >
      {children}
    </ReportsFiltersContext.Provider>
  );
};
